/**
 * Partner Template 2025
 * Main JavaScript file for the partner contact form template
 */

import partnerForm from './components/partner-form';
import trustedPartnersCarousel from './components/trusted-partners-carousel';
import partnersTestimonialsCarousel from './components/partners-testimonials-carousel';

// Initialize partner form when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    partnerForm();
    trustedPartnersCarousel();
    partnersTestimonialsCarousel();
});
